//采购
const addPurchase = () => import('./view/purchase/purchaseManage/addPurchase.vue')
const purchaseList = () => import('./view/purchase/purchaseManage/purchaseList.vue')
const advancedShippingNote = () => import('./view/purchase/purchaseManage/advancedShippingNote.vue')
const advancedShippingNoteDetail = () =>
  import('./view/purchase/purchaseManage/advancedShippingNoteDetail.vue')
const supplierManage = () => import('./view/purchase/supplierManage/supplierManage.vue')
const addSupplier = () => import('./view/purchase/supplierManage/addSupplier.vue')
const purchaseReturnList = () => import('./view/purchase/purchaseReturn/purchaseReturnList.vue')
const addPurchaseReturn = () => import('./view/purchase/purchaseReturn/addPurchaseReturn.vue')
const searchTransfer = () => import('./view/purchase/transferManage/searchTransfer.vue')
const addTransfer = () => import('./view/purchase/transferManage/addTransfer.vue')
const deliveryOrderDetails = () => import('./view/purchase/transferManage/deliveryOrderDetails.vue')
const warehousingOrderDetails = () =>
  import('./view/purchase/transferManage/warehousingOrderDetails.vue')
const supplyChainConfig = () => import('./view/purchase/supplyChainConfig.vue')
const purchasePlan = () => import('./view/purchase/purchasePlan.vue')
const purchaseRequest = () => import('./view/purchase/purchaseRequest/list.vue')
const createPurchaseRequest = () => import('./view/purchase/purchaseRequest/create.vue')
const supplierGoodsRelation = () => import('./view/purchase/supplierGoodsRelation/list.vue')
// Vue.use(VueRouter);

export default [
  {
    path: '/',
    name: 'index',
    redirect: '/purchaseList',
  },
  {
    path: '/supplierManage',
    name: 'supplierManage',
    component: supplierManage, // 供应商管理（全局）
  },
  {
    path: '/addSupplier',
    name: 'addSupplier',
    component: addSupplier, //  创建供应商
  },
  {
    path: '/addPurchase',
    name: 'addPurchase',
    component: addPurchase, // 新建采购单
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/purchaseDetail',
    name: 'purchaseDetail',
    component: addPurchase, // 采购单详情
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/purchaseReturnList',
    name: 'purchaseReturnList',
    component: purchaseReturnList, // 采购退货查询页
  },
  {
    path: '/addPurchaseReturn',
    name: 'addPurchaseReturn',
    component: addPurchaseReturn, // 采购退货新增
  },
  {
    path: '/searchTransfer',
    name: 'searchTransfer',
    component: searchTransfer, // 调拨查询页
  },
  {
    path: '/addTransfer',
    name: 'addTransfer',
    component: addTransfer, // 创建调拨单
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/transferDetail',
    name: 'transferDetail',
    component: addTransfer, // 调拨单详情
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/deliveryOrderDetails',
    name: 'deliveryOrderDetails',
    component: deliveryOrderDetails, // 出库单详情
  },
  {
    path: '/warehousingOrderDetails',
    name: 'warehousingOrderDetails',
    component: warehousingOrderDetails, // 入库单详情
  },
  {
    path: '/addAdvancedShippingNote',
    name: 'addAdvancedShippingNote',
    component: advancedShippingNoteDetail, // 添加预到货
  },
  {
    path: '/advancedShippingNoteDetail',
    name: 'advancedShippingNoteDetail',
    component: advancedShippingNoteDetail, // 预到货单详情
  },
  {
    path: '/purchaseList',
    name: 'purchaseList',
    component: purchaseList, // 采购单查询
  },
  {
    path: '/advancedShippingNote',
    name: 'advancedShippingNote',
    component: advancedShippingNote, //  预到货通知
  },
  {
    path: '/supplyChainConfig',
    name: 'supplyChainConfig',
    component: supplyChainConfig, //  预到货通知
  },
  {
    path: '/purchasePlan',
    name: 'purchasePlan',
    component: purchasePlan, //采购计划
  },
  {
    path: '/purchaseRequest',
    name: 'purchaseRequest',
    component: purchaseRequest, // 采购申请单
  },
  {
    path: '/createPurchaseRequest',
    name: 'createPurchaseRequest',
    component: createPurchaseRequest, // 创建采购申请单
  },
  {
    path: '/supplierGoodsRelation',
    name: 'supplierGoodsRelation',
    component: supplierGoodsRelation, // 商品供应商管理
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./view/common/404'),
  },
  {
    path: '/403',
    name: '403',
    component: () => import('./view/common/403'),
  },
]
